import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Tooltip, TooltipProps } from '@mui/material'
import { CSSProperties, ReactNode, memo } from 'react'
import { isTouchDevice } from '../../../utilities/browser'
import layers from '../../styles/layers'
import { PAPER_HEIGHTS } from '../../theme'

const StyledContainer = styled('div')({
    cursor: 'pointer',
    display: 'flex',
})

export interface ContainerProps {
    children: ReactNode
    shadow?: boolean
    styleOverrides?: CSSProperties
    title?: string
    tooltipPlacement?: TooltipProps['placement']
}

const Container = memo((props: ContainerProps) => {
    const {
        styleOverrides = {},
        shadow = true,
        children,
        title,
        tooltipPlacement = 'top',
    } = props
    const cssStyle = css(
        shadow
            ? {
                  '& svg': {
                      filter: shadow ? `drop-shadow(${layers.icons})` : null,
                  },
              }
            : null,
    )

    if (isTouchDevice || !title) {
        return (
            <StyledContainer
                data-testid="Container__Styled"
                css={cssStyle}
                style={styleOverrides}
            >
                {children}
            </StyledContainer>
        )
    }

    return (
        <Tooltip
            placement={tooltipPlacement}
            title={title}
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        fontWeight: 600,
                        marginBottom: '0px !important',
                        bgcolor: 'common.black',
                        '& .MuiTooltip-arrow': {
                            color: 'common.black',
                        },
                    },
                },

                popper: {
                    modifiers: [
                        tooltipPlacement === 'top'
                            ? {
                                  name: 'offset',
                                  options: {
                                      offset: [0, 10],
                                  },
                              }
                            : {},
                    ],
                    style: {
                        zIndex: PAPER_HEIGHTS.tooltip,
                    },
                },
            }}
        >
            <StyledContainer data-testid="Container__Styled" css={cssStyle}>
                {children}
            </StyledContainer>
        </Tooltip>
    )
})

export default Container
export { Container }
